function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { MenuItem, TextField } from 'seagull';
import { connectControllerToTextField } from "../../../utils/react-hook-form.utils";
const pricingOptions = [{
  text: 'Fixed price',
  value: 'fixed'
}, {
  text: 'Price per hour',
  value: 'hour'
}, {
  text: 'Price per unit',
  value: 'unit'
}, {
  text: 'Price range',
  value: 'range'
}];
export default function PricingTextField() {
  const {
    control
  } = useFormContext();
  return /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "pricing",
    render: renderProps => /*#__PURE__*/React.createElement(TextField, _extends({
      select: true
    }, connectControllerToTextField(renderProps), {
      label: "Pricing",
      "data-testid": "sb-pricing"
    }), pricingOptions.map(_ref => {
      let {
        value,
        text
      } = _ref;
      return /*#__PURE__*/React.createElement(MenuItem, {
        key: value,
        value: value,
        "data-testid": "sb-pricing-opt-".concat(value)
      }, text);
    }))
  });
}